import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anon, obj = user
  const [booted, setBooted] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch (e) {
        // Solo desloguear si el servidor confirma sesión inválida (401/403).
        // Errores 5xx, 502, 504, 520, timeout de red o Cloudflare son transitorios
        // y NO deben expulsar al admin — mantener la sesión pendiente y reintentará
        // al próximo request. Antes cualquier hipo de red mataba el login.
        const status = e?.response?.status;
        const hasToken = !!localStorage.getItem("fm_token");
        if (status === 401 || status === 403) {
          localStorage.removeItem("fm_token");
          setUser(false);
        } else if (hasToken) {
          // Sesión probablemente aún válida; asumimos autenticado provisionalmente.
          // Un request real posterior confirmará; si devuelve 401 se limpiará.
          setUser({ email: "", pending_verify: true });
        } else {
          setUser(false);
        }
      } finally {
        setBooted(true);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("fm_token", data.token);
    setUser(data);
    return data;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    if (data.token) localStorage.setItem("fm_token", data.token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) { /* ignore network errors on logout */ }
    localStorage.removeItem("fm_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, booted, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
